// Types
import type { Media } from '../../../server/src/types/media.types';

// Utils
import { filterMedia } from 'utils/filterGeneric';

export const filterAudio = (
  media: Media[] | undefined,
  search: string
): Media[] => filterMedia(media, search);
